import { useState, useEffect } from 'react'
import { gql, useQuery } from '@apollo/client'
import { mergeWith } from 'lodash'

export const GET_MEMBERSHIP = gql`
  query getMembership {
    me {
      name
      email
      familyCupSignedUp
      jrlSignedUp
      programAdmin
      contactPreference
      dateOfBirth
      phone
      gender
      state
      zip
      city
      pgaCoachEligible
    }
    pgaMembership {
      birthdate
      displayName
      firstName
      lastName
      publicEmail
      publicMobile
      type
      gender
      state
      zip
      city
    }
  }
`

const eligibleTypes = {
  MB: true,
  ST: true,
  AP: true,
}

export default function useEligibilityCheck() {
  const { data, error } = useQuery(GET_MEMBERSHIP)

  const [defaults, setDefaults] = useState()
  const [eligible, setEligible] = useState(false)
  const [signedUp, setSignedUp] = useState(false)
  const [jrlSignedUp, setJRLSignedUp] = useState(false)
  const [admin, setAdmin] = useState(false)
  const [eligibleMemberType, setEligibleMemberType] = useState(false)
  const [checked, setChecked] = useState(false)

  useEffect(() => {
    if (!data || !data.pgaMembership) return
    const defaultValues = {
      displayName: data.pgaMembership.displayName,
      phoneNumber: data.pgaMembership.publicMobile,
      email: data.pgaMembership.publicEmail,
      firstName: data.pgaMembership.firstName,
      lastName: data.pgaMembership.lastName,
      dateOfBirth: data.pgaMembership.birthdate,
      gender: data.pgaMembership.gender,
      state: data.pgaMembership.state,
      zip: data.pgaMembership.zip,
      city: data.pgaMembership.city,
    }

    if (data.me.jrlSignedUp || data.me.familyCupSignedUp) {
      const localDefaultValues = {
        displayName: data.me.name,
        phoneNumber: data.me.phone,
        email: data.me.email,
        dateOfBirth: data.me.dateOfBirth,
        gender: data.me.gender,
        state: data.me.state,
        zip: data.me.zip,
        city: data.me.city,
        contactMethod: data.me.contactPreference,
      }

      const defaultsOverriddenWithLocal = mergeWith(
        {},
        defaultValues,
        localDefaultValues,
        (a, b) => (b == null ? a : undefined),
      )

      setDefaults(defaultsOverriddenWithLocal)
    } else {
      setDefaults(defaultValues)
    }

    setEligible(data.me.pgaCoachEligible)

    const eligibleType =
      !!data.pgaMembership.type && eligibleTypes[data.pgaMembership.type]
    setEligibleMemberType(eligibleType)
    setSignedUp(data.me.familyCupSignedUp)
    setJRLSignedUp(data.me.jrlSignedUp)
    setAdmin(data.me.programAdmin)
    setChecked(true)
  }, [data])

  useEffect(() => {
    if (error) {
      setChecked(true)
    }
  }, [error])

  return {
    defaults,
    error,
    eligible,
    signedUp,
    jrlSignedUp,
    admin,
    eligibleMemberType,
    loading: !checked,
  }
}
